import React, { FC, useState } from 'react';

import { OptionProps } from '../../types';
import {
  DropdownDeprecated,
  DropdownDeprecatedProps,
} from '../deprecated/DropdownDeprecated';

interface SearchProps extends DropdownDeprecatedProps {
  results?: OptionProps[];
  keepValue?: boolean;
  onChange?: (keyword) => void;
  onSearch: (keyword) => void;
  value?: string;
}

export const Search: FC<SearchProps> = ({
  results,
  className,
  testId,
  value = '',
  keepValue = false,
  onSearch,
  onChange,
  onOptionSelect,
}) => {
  const [keyword, setKeyword] = useState('');
  const options = results ?? [];

  const onInputChange = (value: string) => {
    setKeyword(value);

    if (onSearch) {
      onSearch(value);
    }

    if (onChange) {
      onChange(value);
    }
  };

  const onSelectingOption = (option) => {
    const value = (keepValue && option.value) || '';
    setKeyword(value);

    if (onOptionSelect) {
      onOptionSelect(option);
    }
  };

  return (
    <DropdownDeprecated
      className={className}
      value={keyword || value}
      readOnly={false}
      options={options}
      isSettingState={keepValue}
      onOptionSelect={onSelectingOption}
      onInputChange={onInputChange}
      testId={testId}
    />
  );
};
